
import { useSelector } from 'react-redux';

import { FilterType, IDashboardReportState } from '@store/slices';
import { InputFilterType } from '@share/common-types';

import { DashboardReportTopBase } from '../dashboard-report-top-base';

import './style.scss';
import { IntlShape } from 'react-intl';

export function DashboardReportTopMembers({intl, filterValue}: {intl: IntlShape, filterValue: string}) {
  const { loading, dashBoardData } = useSelector((state: { dashboardReportsStore: IDashboardReportState }) => state.dashboardReportsStore);
  
  const topMembersHomes = filterValue === FilterType.HOTELS || filterValue === FilterType.ALL ? dashBoardData?.topMembersHomes : dashBoardData?.topMembersCars;

  return (
    <DashboardReportTopBase topList={topMembersHomes} loading={loading} header={[
      { key: 'leadName', description: intl.formatMessage({ id: 'leadName' }),width: 100, type: InputFilterType.Text, display: true },
      { key: 'numberOfBookings', description: intl.formatMessage({ id: 'bookings' }), width: 60, type: InputFilterType.IntegerNumber, display: true },
      { key: 'totalSpent', description: intl.formatMessage({ id: 'totalSpent' }), width: 75, type: InputFilterType.Currency, display: true }]}
    />
  );
}
